/* eslint-disable */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Exactly } from './utils'

export type OperationWithAxiosResponse = <T extends Exactly<Request, T>>(request: T) => Promise<AxiosResponse<void>>
export const operationWithAxiosResponse = <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<AxiosResponse<void>> => {
  return axios.request({
    url: `/user/${encodeURIComponent(request.path['email'] as any)}/send-verification`,
    // @ts-ignore for sm-axios
    urlTemplate: '/user/{email}/send-verification',
    method: 'POST',
    headers: request.headers,
  })
}

/**
 * sends verification email
 */
export type Operation = <T extends Exactly<Request, T>>(request: T) => Promise<void>
export const operation = async <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<void> => {
  await operationWithAxiosResponse(axios, request)
}

export interface Request {
  headers?: {
    'x-sm-trace-token'?: string
  }
  path: {
    email: string
  }
}

